import { call, put, takeEvery } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import UsersService from '@/users/service';
import actions from '../constants';
import applyWebsocket from '../actions';

export function* websocket() {
  const { response, error } = yield call(callAdapter, UsersService.currentUser());
  if (!error) {
    yield put(applyWebsocket(response.preferences.websocket));
  }
}

export default function* websocketApi() {
  yield takeEvery(actions.FETCH_WEBSOCKET, websocket);
}
